import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Boxes, Globe2, PenTool } from "lucide-react";
import { BulkQuoteDialog } from "@/components/BulkQuoteDialog";

const POINTS = [
  { icon: Boxes, text: "Bulk & OEM orders with export-ready packaging" },
  { icon: PenTool, text: "Custom covers, foiling, ruling — end to end" },
  { icon: Globe2, text: "Trusted by partners across 20+ countries" },
];

export const TradeSection = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <section id="trade" className="py-24 md:py-28 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-xs uppercase tracking-[0.25em] font-bold opacity-70 mb-4">02 · Trade & Bulk</p>
          <h2 className="font-serif text-3xl md:text-5xl font-medium tracking-tight leading-tight">
            Buying for a school, <span className="italic">office or business?</span>
          </h2>
          <p className="mt-5 opacity-80 leading-relaxed max-w-lg">
            Get manufacturer-direct pricing for bulk quantities. Distributors, retailers, schools and
            corporate gifting partners — request a quote for trade pricing, sample kits and custom covers.
          </p>
          <button
            data-testid="trade-cta-button"
            onClick={() => setQuoteOpen(true)}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-background text-foreground px-8 py-3.5 text-sm font-bold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
          >
            Request a bulk quote <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>

        <div className="space-y-5">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.text}
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.6 }}
              className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-2xl px-6 py-5 border border-white/10"
            >
              <p.icon className="w-5 h-5 shrink-0" />
              <p className="text-sm font-medium">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>

      <BulkQuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </section>
  );
};
